import IcNovelties from './IcNovelties'
export default IcNovelties
